
// Bootstrap スクロールスパイの初期化
document.addEventListener('DOMContentLoaded', function() {
    document.body.setAttribute('data-bs-spy', 'scroll');
    document.body.setAttribute('data-bs-target', '#global-nav');
    document.body.setAttribute('data-bs-offset', '200');
    
    // Bootstrap ScrollSpyの初期化
    if (typeof bootstrap !== 'undefined' && bootstrap.ScrollSpy) {
        new bootstrap.ScrollSpy(document.body, {
            target: '#global-nav',
            offset: 200
        });
    }
    
    // モバイルメニューの開閉機能
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuHeader = document.getElementById('mobile-menu-header');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuClose = document.querySelector('.mobile-menu-close');
    const mobileMenuLinks = document.querySelectorAll('.mobile-menu-link, .mobile-nav-link');
    
    function openMobileMenu(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (mobileMenu && mobileMenuOverlay && mobileMenuToggle) {
            mobileMenu.classList.add('active');
            if (mobileMenuHeader) {
                mobileMenuHeader.classList.add('active');
            }
            mobileMenuOverlay.classList.add('active');
            mobileMenuToggle.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
        }
    }
    
    function closeMobileMenu(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (mobileMenu) {
            mobileMenu.classList.remove('active');
        }
        if (mobileMenuHeader) {
            mobileMenuHeader.classList.remove('active');
        }
        if (mobileMenuOverlay) {
            mobileMenuOverlay.classList.remove('active');
        }
        if (mobileMenuToggle) {
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
        }
        document.body.style.overflow = '';
    }
    
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', openMobileMenu);
    }
    
    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', function(e) {
            // ヘッダー部分をクリックした場合は閉じない
            const header = document.getElementById('mobile-menu-header');
            if (header && header.contains(e.target)) {
                return;
            }
            closeMobileMenu(e);
        });
    }
    
    // メニュー内のリンクをクリックしたらメニューを閉じる
    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', function() {
            // アンカーリンクの場合は少し遅延させてから閉じる
            if (this.getAttribute('href') && this.getAttribute('href').includes('#')) {
                setTimeout(closeMobileMenu, 300);
            } else {
                closeMobileMenu();
            }
        });
    });
    
    // ESCキーでメニューを閉じる
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
            closeMobileMenu();
        }
    });
});